















import { Component, Mixins } from 'vue-property-decorator';
import isIntalentCheck from '@/mixins/isIntalentCheck';
import { Block, Smart } from './components';
import { getAge } from '@/tools/getAgeFromBirthday';
import { get } from 'lodash';
import { IUser, ICareerGuidance, TestResult } from './types';

@Component({
  components: {
    Block,
    Smart,
  },
  metaInfo: () => ({
    title: 'Профориентация',
  }),
})
export default class CareerGuidance
  extends Mixins(isIntalentCheck)
  implements ICareerGuidance
{
  // Computed
  get user(): IUser {
    return this.$store.state.user;
  }

  get id(): string {
    return get(this.user, 'profile.id', null);
  }

  get name(): string {
    const { user } = this;
    return get(this.user, 'profile.id')
      ? `${user.profile.first_name} ${user.profile.last_name}`
      : 'обучающийся';
  }

  get age(): string {
    return get(this.user, 'profile.birthday')
      ? getAge(this.user.profile.birthday).toString()
      : '';
  }

  get municipalityId(): string {
    return get(this.user, 'profile.municipality_id') || '';
  }

  get testResult(): TestResult {
    return get(this.user, 'profile.intalent_result')
      ? get(this.user, 'profile.intalent_result')
      : ({} as any);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/career-guidance/CareerGuidance.vue